module.exports = __webpack_public_path__ + "img/maskot.372af86e.png";